export default __webpack_public_path__ + "static/media/add.ca1bc826.svg";